// TRAVA PTAX da Posição do Dia. A taxa (PTAX de COMPRA do último fechamento
// anterior ao dia) é resolvida no backend, pela mesma função do export
// (resolver_ptax_compra_d1, server.py). A tela só exibe o que veio em
// dados.trava_ptax — nunca recalcula nem cai para a PTAX do dia.

const ddmm = (iso) => {
  if (!iso) return "";
  const [, m, d] = iso.split("-");
  return `${d}/${m}`;
};

// Campos da linha montada em buildRows a partir de dados.trava_ptax.
export const linhaTravaPtax = (tp) => {
  const montante = tp?.montante_usd ?? null;
  return {
    montante_usd: montante,
    taxa_venda: null,
    taxa_compra: montante != null ? (tp?.taxa_compra ?? null) : null,
    ptax_data_cotacao: tp?.ptax_data_cotacao ?? null,
    ptax_indisponivel: montante != null && !!tp?.ptax_indisponivel,
    quantidade_travas: tp?.quantidade_travas ?? 0,
  };
};

// Rótulo sob a taxa: "PTAX compra · dd/mm" com a data da cotação usada, ou
// o aviso de indisponível. null quando não há trava PTAX no dia.
export const rotuloTravaPtax = (linha) => {
  if (linha?.ptax_indisponivel) return "PTAX compra D-1 indisponível";
  if (linha?.taxa_compra != null && linha?.ptax_data_cotacao) {
    return `PTAX compra · ${ddmm(linha.ptax_data_cotacao)}`;
  }
  return null;
};
